window.theme = window.theme || {};

Shopify.formatMoney = function (cents, format) {
  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* ================ SLATE ================ */
window.theme = window.theme || {};

/*! jquery-dateFormat 18-05-2015 */
var DateFormat = {};
!(function (a) {
  var b = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    c = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    d = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    e = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    f = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    },
    g = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.?\d{0,3}[Z\-+]?(\d{2}:?\d{2})?/;
  a.format = (function () {
    function a(a) {
      return b[parseInt(a, 10)] || a;
    }
    function h(a) {
      return c[parseInt(a, 10)] || a;
    }
    function i(a) {
      var b = parseInt(a, 10) - 1;
      return d[b] || a;
    }
    function j(a) {
      var b = parseInt(a, 10) - 1;
      return e[b] || a;
    }
    function k(a) {
      return f[a] || a;
    }
    function l(a) {
      var b,
        c,
        d,
        e,
        f,
        g = a,
        h = "";
      return (
        -1 !== g.indexOf(".") && ((e = g.split(".")), (g = e[0]), (h = e[e.length - 1])),
        (f = g.split(":")),
        3 === f.length
          ? ((b = f[0]),
            (c = f[1]),
            (d = f[2].replace(/\s.+/, "").replace(/[a-z]/gi, "")),
            (g = g.replace(/\s.+/, "").replace(/[a-z]/gi, "")),
            { time: g, hour: b, minute: c, second: d, millis: h })
          : { time: "", hour: "", minute: "", second: "", millis: "" }
      );
    }
    function m(a, b) {
      for (var c = b - String(a).length, d = 0; c > d; d++) a = "0" + a;
      return a;
    }
    return {
      parseDate: function (a) {
        var b,
          c,
          d = {
            date: null,
            year: null,
            month: null,
            dayOfMonth: null,
            dayOfWeek: null,
            time: null,
          };
        if ("number" == typeof a) return this.parseDate(new Date(a));
        if ("function" == typeof a.getFullYear)
          (d.year = String(a.getFullYear())),
            (d.month = String(a.getMonth() + 1)),
            (d.dayOfMonth = String(a.getDate())),
            (d.time = l(a.toTimeString() + "." + a.getMilliseconds()));
        else if (-1 != a.search(g))
          (b = a.split(/[T\+-]/)),
            (d.year = b[0]),
            (d.month = b[1]),
            (d.dayOfMonth = b[2]),
            (d.time = l(b[3].split(".")[0]));
        else
          switch (
            ((b = a.split(" ")), 6 === b.length && isNaN(b[5]) && (b[b.length] = "()"), b.length)
          ) {
            case 6:
              (d.year = b[5]), (d.month = k(b[1])), (d.dayOfMonth = b[2]), (d.time = l(b[3]));
              break;
            case 2:
              (c = b[0].split("-")),
                (d.year = c[0]),
                (d.month = c[1]),
                (d.dayOfMonth = c[2]),
                (d.time = l(b[1]));
              break;
            case 7:
            case 9:
            case 10:
              (d.year = b[3]), (d.month = k(b[1])), (d.dayOfMonth = b[2]), (d.time = l(b[4]));
              break;
            case 1:
              (c = b[0].split("")),
                (d.year = c[0] + c[1] + c[2] + c[3]),
                (d.month = c[5] + c[6]),
                (d.dayOfMonth = c[8] + c[9]),
                (d.time = l(c[13] + c[14] + c[15] + c[16] + c[17] + c[18] + c[19] + c[20]));
              break;
            default:
              return null;
          }
        return (
          (d.date = d.time
            ? new Date(
                d.year,
                d.month - 1,
                d.dayOfMonth,
                d.time.hour,
                d.time.minute,
                d.time.second,
                d.time.millis,
              )
            : new Date(d.year, d.month - 1, d.dayOfMonth)),
          (d.dayOfWeek = String(d.date.getDay())),
          d
        );
      },
      date: function (b, c) {
        try {
          var d = this.parseDate(b);
          if (null === d) return b;
          for (
            var e,
              f = d.year,
              g = d.month,
              k = d.dayOfMonth,
              l = d.dayOfWeek,
              n = d.time,
              o = "",
              p = "",
              q = "",
              r = !1,
              s = 0;
            s < c.length;
            s++
          ) {
            var t = c.charAt(s),
              u = c.charAt(s + 1);
            if (r) "'" == t ? ((p += "" === o ? "'" : o), (o = ""), (r = !1)) : (o += t);
            else
              switch (((o += t), (q = ""), o)) {
                case "ddd":
                  (p += a(l)), (o = "");
                  break;
                case "dd":
                  if ("d" === u) break;
                  (p += m(k, 2)), (o = "");
                  break;
                case "d":
                  if ("d" === u) break;
                  (p += parseInt(k, 10)), (o = "");
                  break;
                case "D":
                  (k =
                    1 == k || 21 == k || 31 == k
                      ? parseInt(k, 10) + "st"
                      : 2 == k || 22 == k
                        ? parseInt(k, 10) + "nd"
                        : 3 == k || 23 == k
                          ? parseInt(k, 10) + "rd"
                          : parseInt(k, 10) + "th"),
                    (p += k),
                    (o = "");
                  break;
                case "MMMM":
                  (p += j(g)), (o = "");
                  break;
                case "MMM":
                  if ("M" === u) break;
                  (p += i(g)), (o = "");
                  break;
                case "MM":
                  if ("M" === u) break;
                  (p += m(g, 2)), (o = "");
                  break;
                case "M":
                  if ("M" === u) break;
                  (p += parseInt(g, 10)), (o = "");
                  break;
                case "y":
                case "yyy":
                  if ("y" === u) break;
                  (p += o), (o = "");
                  break;
                case "yy":
                  if ("y" === u) break;
                  (p += String(f).slice(-2)), (o = "");
                  break;
                case "yyyy":
                  (p += f), (o = "");
                  break;
                case "HH":
                  (p += m(n.hour, 2)), (o = "");
                  break;
                case "H":
                  if ("H" === u) break;
                  (p += parseInt(n.hour, 10)), (o = "");
                  break;
                case "hh":
                  (e = 0 === parseInt(n.hour, 10) ? 12 : n.hour < 13 ? n.hour : n.hour - 12),
                    (p += m(e, 2)),
                    (o = "");
                  break;
                case "h":
                  if ("h" === u) break;
                  (e = 0 === parseInt(n.hour, 10) ? 12 : n.hour < 13 ? n.hour : n.hour - 12),
                    (p += parseInt(e, 10)),
                    (o = "");
                  break;
                case "mm":
                  (p += m(n.minute, 2)), (o = "");
                  break;
                case "m":
                  if ("m" === u) break;
                  (p += n.minute), (o = "");
                  break;
                case "ss":
                  (p += m(n.second.substring(0, 2), 2)), (o = "");
                  break;
                case "s":
                  if ("s" === u) break;
                  (p += n.second), (o = "");
                  break;
                case "S":
                case "SS":
                  if ("S" === u) break;
                  (p += o), (o = "");
                  break;
                case "SSS":
                  var v = "000" + n.millis.substring(0, 3);
                  (p += v.substring(v.length - 3)), (o = "");
                  break;
                case "a":
                  (p += n.hour >= 12 ? "PM" : "AM"), (o = "");
                  break;
                case "p":
                  (p += n.hour >= 12 ? "p.m." : "a.m."), (o = "");
                  break;
                case "E":
                  (p += h(l)), (o = "");
                  break;
                case "'":
                  (o = ""), (r = !0);
                  break;
                default:
                  (p += t), (o = "");
              }
          }
          return (p += q);
        } catch (w) {
          return console && console.log && console.log(w), b;
        }
      },
      prettyDate: function (a) {
        var b, c, d;
        return (
          ("string" == typeof a || "number" == typeof a) && (b = new Date(a)),
          "object" == typeof a && (b = new Date(a.toString())),
          (c = (new Date().getTime() - b.getTime()) / 1e3),
          (d = Math.floor(c / 86400)),
          isNaN(d) || 0 > d
            ? void 0
            : 60 > c
              ? "just now"
              : 120 > c
                ? "1 minute ago"
                : 3600 > c
                  ? Math.floor(c / 60) + " minutes ago"
                  : 7200 > c
                    ? "1 hour ago"
                    : 86400 > c
                      ? Math.floor(c / 3600) + " hours ago"
                      : 1 === d
                        ? "Yesterday"
                        : 7 > d
                          ? d + " days ago"
                          : 31 > d
                            ? Math.ceil(d / 7) + " weeks ago"
                            : d >= 31
                              ? "more than 5 weeks ago"
                              : void 0
        );
      },
      toBrowserTimeZone: function (a, b) {
        return this.date(new Date(a), b || "MM/dd/yyyy HH:mm:ss");
      },
    };
  })();
})(DateFormat),
  (function (a) {
    a.format = DateFormat.format;
  })(jQuery);

// DBD Modules
class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.section_wrapper = this.closest("header");
    this.outer_wrapper = this.closest(".site-header__outer");
    this.padding =
      parseInt(window.getComputedStyle(this).getPropertyValue("padding-left").replace("px", "")) *
      2;

    this.nav_track = this.querySelector(".main-navigation__inner");
    this.nav_items = this.querySelectorAll(".main-navigation__parent-item");

    this.min_track_width = 0;
    this.nav_items.forEach((item) => {
      const width = item.getBoundingClientRect().width;
      this.min_track_width = this.min_track_width + width;
    });
  }

  connectedCallback() {
    this.addEventListeners();
    this.collapseNavigation();
  }

  addEventListeners() {
    window.addEventListener("scroll", this.stickyNavigation.bind(this));
    window.addEventListener("resize", this.collapseNavigation.bind(this));
    window.addEventListener("DOMContentLoaded", this.collapseNavigation.bind(this));
  }

  stickyNavigation() {
    const wrapper = this.section_wrapper.getBoundingClientRect();
    if (window.scrollY > wrapper.top) {
      this.outer_wrapper.classList.add("site-header__sticky");
    } else {
      this.outer_wrapper.classList.remove("site-header__sticky");
    }
  }

  collapseNavigation() {
    if (window.innerWidth - this.padding < this.min_track_width) {
      this.outer_wrapper.classList.add("site-header__collapse");
    } else {
      this.outer_wrapper.classList.remove("site-header__collapse");
    }
  }
}

customElements.define("site-header", SiteHeader);

class DropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.is_touch) {
      this.addEventListener("click", this.clickHandler.bind(this));
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    } else {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest('[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("dropdown-menu") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseenter") {
      this.setVisible();
    } else if (e.type === "mouseleave") {
      this.toggle_button.blur();
      this.setHidden();
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      this.toggleMenu();
    }
    if (e.key === "Escape") {
      this.setHidden();
    }
  }

  toggleMenu() {
    if (this.getAttribute("dropdown-view") === "hidden") {
      this.setVisible();
    } else if (this.getAttribute("dropdown-view") === "visible") {
      this.setHidden();
    }
  }

  setHidden() {
    this.is_open = false;
    this.setAttribute("dropdown-view", "hidden");
    this.toggle_button.setAttribute("aria-expanded", "false");
  }

  setVisible() {
    this.is_open = true;
    this.setAttribute("dropdown-view", "visible");
    this.toggle_button.setAttribute("aria-expanded", "true");
  }
}

customElements.define("dropdown-menu", DropdownMenu);

class CartDropdown extends DropdownMenu {
  constructor() {
    super();
    this.toast_timer = null;
    this.toast_interval = 100;
    this.toast_age = 3000;
    this.toast_remaining = this.toast_age;
    this.toast_paused = false;
    this.toast_container = this.querySelector("[dropdown-action-toast]");
    this.toast_icon = this.querySelector(".toast__icon");
    this.toast_message = this.querySelector(".toast__message");
    this.toast_clock = this.querySelector(".toast__timer--inner");
    this.maxHeightHandler();
    this.addCartEventListeners();
  }

  addCartEventListeners() {
    window.addEventListener("resize", this.maxHeightHandler.bind(this));
    document.addEventListener("cart:update", this.updateCart.bind(this));
    document.addEventListener("line:update", this.updateCart.bind(this));
    document.addEventListener("cart:add:success", this.showToast.bind(this));
    document.addEventListener("cart:add:error", this.showToast.bind(this));
    if (!this.is_touch) {
      this.addEventListener("mousemove", this.mouseHandler.bind(this));
      this.toast_container.addEventListener("mouseenter", this.pauseToast.bind(this));
      this.toast_container.addEventListener("mouseleave", this.startToast.bind(this));
    }
  }

  maxHeightHandler() {
    const dropdown = this.querySelector(".dropdown-menu__list");
    const dropdown_position = dropdown.getBoundingClientRect().top;
    dropdown.style.maxHeight = window.innerHeight - dropdown_position - 10 + "px";
  }

  outsideClickHandler(e) {
    if (e.target.closest("cart-dropdown") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseenter" && this.getAttribute("dropdown-toast") === "hidden") {
      this.setVisible();
    } else if (e.type === "mouseleave") {
      this.toggle_button.blur();
      this.setHidden();
    } else if (e.type === "mousemove" && !e.target.closest(".dropdown-menu__toast")) {
      this.setVisible();
      this.resetToast();
    }
  }

  showToast(e) {
    this.resetToast();
    const type = e.detail.type;
    if (type === "success") {
      const title = e.detail.data.title;
      this.toast_icon.classList.add("toast__success");
      this.toast_message.innerHTML = `<span>${title}</span> was added to your basket`;
    } else {
      this.toast_icon.classList.add("toast__error");
      this.toast_message.innerHTML = `${e.detail.error}`;
    }
    this.toast_container.setAttribute("role", "alert");
    this.setAttribute("dropdown-toast", "visible");
    this.startToast();
  }

  pauseToast(e) {
    clearInterval(this.toast_timer);
    this.toast_timer = null;
  }

  startToast(e) {
    if (this.toast_remaining <= 0) {
      this.toast_remaining = this.toast_age;
    }
    this.toast_timer = setInterval(() => {
      this.updateToast();
    }, this.toast_interval);
  }

  updateToast() {
    if (this.toast_remaining <= 0) {
      this.resetToast();
    }
    this.toast_remaining = this.toast_remaining - this.toast_interval;
    const percentage = (100 / this.toast_age) * this.toast_remaining;
    this.toast_clock.style.width = `${percentage}%`;
  }

  resetToast() {
    clearInterval(this.toast_timer);
    this.toast_timer = null;
    this.setAttribute("dropdown-toast", "hidden");
    this.toast_clock.removeAttribute("style");
    this.toast_container.removeAttribute("role");
    this.toast_icon.className = "toast__icon";
    this.toast_remaining = this.toast_age;
  }

  updateCart(e) {
    this.updateTotals(e);
    const items = e.detail.data.items;

    if (items.length <= 0) {
      this.classList.add("site-header__cart-empty");
      this.querySelector(".dropdown-menu__icon").classList.remove("dropdown-menu__expand-button");
    } else {
      this.classList.remove("site-header__cart-empty");
      this.querySelector(".dropdown-menu__icon").classList.add("dropdown-menu__expand-button");
    }
  }

  updateTotals(e) {
    const totals = this.querySelectorAll(".dropdown-menu__price");
    totals.forEach((total) => {
      total.innerHTML = Shopify.formatMoney(
        e.detail.data.items_subtotal_price * theme.discountModifier,
        theme.moneyFormat,
      );
    });
  }
}
customElements.define("cart-dropdown", CartDropdown);

class CartSummary extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".cart-summary-content");
    this.content_body = this.querySelector(".cart-summary-body");
    this.drawer = this.querySelector(".cart-summary-drawer");
    this.buttons = this.querySelector(".cart-page__buttons");
    this.saveButtons = null;
    this.clearButtons = null;
    this.drawerOpenTransition = null;
    this.drawerCloseTransition = null;
    this.orderMinActive = this.buttons.dataset.cartMinimum === "true" ? true : false;
    this.orderMin = parseInt(this.buttons.dataset.cartThreshold);
    this.orderMinMessage = this.buttons.dataset.warningMessage;
  }

  connectedCallback() {
    this.content.style.height = this.content_body.scrollHeight + "px";
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.handleClick.bind(this));
    document.addEventListener("cart:update", this.updateCart.bind(this));
    document.addEventListener("line:update", this.updateCart.bind(this));
    document.addEventListener("cart:updating", this.checkoutAction.bind(this));
  }

  handleClick(e) {
    if (
      e.target.classList.contains("cart-page__additional") ||
      e.target.closest(".cart-page__additional")
    ) {
      if (e.target.tagName !== "A") {
        this.openDrawer(e.target.closest(".cart-page__additional").dataset.drawerHandle);
      }
    }
    if (
      e.target.classList.contains("cart-summary-drawer-close") ||
      e.target.closest(".cart-summary-drawer-close")
    ) {
      this.closeDrawer(this.content.dataset.openDrawer);
    }
    if (e.target.classList.contains("cart-page__clear")) {
      this.clearInput(e);
    }
    if (e.target.classList.contains("cart-page__save")) {
      this.saveInput(e);
    }
    if (e.target.classList.contains("cart-page__checkout")) {
      this.checkoutAction();
    }
  }

  checkoutAction(e) {
    const button = this.querySelector(".cart-page__checkout");
    if (e && e.detail.type === "end") {
      button.innerHTML = theme.strings.cart.checkout;
      button.classList.remove("loading-checkout");
      this.updateOrderMin();
    } else {
      button.innerHTML = "&nbsp;";
      button.classList.add("loading-checkout");
    }
  }

  openDrawer(drawer_id) {
    clearTimeout(this.drawerCloseTransition);
    const drawer_content = this.content.querySelector(`[data-drawer=${drawer_id}]`);
    drawer_content.classList.add("cart-page__drawer-open");
    this.content.classList.add("sidebar-drawer-open");
    this.drawerOpenTransition = setTimeout(() => {
      this.content.style.height = this.drawer.scrollHeight + "px";
    }, 500);
    this.content.dataset.openDrawer = drawer_id;
  }

  closeDrawer(drawer_id) {
    clearTimeout(this.drawerOpenTransition);
    const drawer_content = this.content.querySelector(`[data-drawer=${drawer_id}]`);
    this.content.classList.remove("sidebar-drawer-open");
    this.drawerCloseTransition = setTimeout(() => {
      this.content.style.height = this.content_body.scrollHeight + "px";
      drawer_content.classList.remove("cart-page__drawer-open");
    }, 499);
    this.content.dataset.openDrawer = "";
  }

  async saveInput(e) {
    const updatedInputId = e.target.closest("[data-drawer]").dataset.drawer;
    const input = e.target.closest("[data-drawer]").querySelector(".cart-page__input-element");
    const storedInput = this.content.querySelector(`[data-input="${updatedInputId}"]`);
    const dataWrapper = this.content.querySelector(`.cart-page__additional-data`);
    if (input.value.length > 0) {
      storedInput.value = input.value;
      storedInput.nextElementSibling.innerText = input.value;
      dataWrapper.classList.remove("date-empty");
      await this.updateCartAttributes(e, updatedInputId, input.value);
    } else {
      dataWrapper.classList.add("date-empty");
    }
    this.closeDrawer(updatedInputId);
  }

  async clearInput(e) {
    const updatedInputId = e.target.closest("[data-drawer]").dataset.drawer;
    const input = e.target.closest("[data-drawer]").querySelector(".cart-page__input-element");
    const storedInput = this.content.querySelector(`[data-input="${updatedInputId}"]`);
    const dataWrapper = this.content.querySelector(`.cart-page__additional-data`);
    dataWrapper.classList.add("date-empty");

    await this.updateCartAttributes(e, updatedInputId);

    input.value = "";
    storedInput.value = "";

    storedInput.nextElementSibling.innerText = input.getAttribute("placeholder") || "";
    if (updatedInputId === "delivery") {
      const event = new CustomEvent("cleardate");
      document.dispatchEvent(event);
    }
  }

  async updateCartAttributes(e, updatedInputId, value = null) {
    const button = e.target;
    const spinner = document.createElement("span");
    spinner.classList.add("loading-spinner");
    button.append(spinner);
    button.setAttribute("disabled", "disabled");
    const cartData = {};
    switch (updatedInputId) {
      case "instructions":
        cartData.note = value ? value : "";
        break;
      case "delivery":
        cartData.attributes = {
          date: value,
        };
        break;
    }
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartData),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(JSON.stringify(`${data.status} - ${data.message}: ${data.description}`));
      }
    } catch (err) {
      console.log(err);
    }
    setTimeout(() => {
      button.removeAttribute("disabled");
      spinner.remove();
    }, 500);
  }

  updateCart(e) {
    this.updateTotals(e);
    const items = e.detail.data.items;
    setTimeout(() => {
      this.content.style.height = this.content_body.scrollHeight + "px";
    }, 499);
    if (items.length <= 0) {
      window.location.reload();
    }
  }

  updateTotals(e) {
    this.total = e.detail.data.items_subtotal_price * theme.discountModifier;
    const subtotal = this.querySelector(".cart-page__totals-subtotal");
    const saving = this.querySelector(".cart-page__totals-saving");
    const total = this.querySelector(".cart-page__totals-total");
    subtotal.innerHTML = Shopify.formatMoney(e.detail.data.items_subtotal_price, theme.moneyFormat);
    if (saving) {
      saving.innerHTML = `<em>-${Shopify.formatMoney(
        e.detail.data.items_subtotal_price -
          e.detail.data.items_subtotal_price * theme.discountModifier,
        theme.moneyFormat,
      )}</em>`;
    }
    total.innerHTML = Shopify.formatMoney(
      e.detail.data.items_subtotal_price * theme.discountModifier,
      theme.moneyFormat,
    );
  }

  updateOrderMin() {
    if (!this.orderMinActive) return;
    const checkoutBtn = this.buttons.querySelector("button");
    if (this.total < this.orderMin) {
      checkoutBtn.classList.add("btn-style__disabled");
      checkoutBtn.removeAttribute("name");
      checkoutBtn.removeAttribute("type");
      checkoutBtn.innerHTML = this.orderMinMessage;
    } else {
      checkoutBtn.classList.remove("btn-style__disabled");
      checkoutBtn.setAttribute("name", "checkout");
      checkoutBtn.setAttribute("type", "submit");
      checkoutBtn.innerHTML = theme.strings.cart.checkout;
    }
  }
}
customElements.define("cart-summary", CartSummary);

class MainCart extends HTMLElement {
  constructor() {
    super();

    this.reload = this.getAttribute("reload") || false;
  }
  async connectedCallback() {
    if (this.reload) {
      this.rebuildCart();
    } else {
      // hotfix: force credit type through to cart attributes, do not remove
      this.applyCustomerCredit();
      // endhotfix
    }
  }
  async applyCustomerCredit() {
    const customer_credit_id = this.querySelector('input[name="attributes[__customer_credit_id]"]');

    if (!customer_credit_id) return;

    const cartAttributes = { attributes: {} };

    cartAttributes.attributes["__customer_credit_id"] = customer_credit_id.value;
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartAttributes),
      });
    } catch (error) {
      console.log(error);
    }
  }
  async rebuildCart() {
    let start = new CustomEvent("cart:updating", {
      detail: {
        type: "start",
      },
    });
    document.dispatchEvent(start);
    // create new items array to add to cart
    const formData = new FormData(this.querySelector("form"));
    const current = {
      items: [],
    };
    const skip = [];
    for (const [key, value] of formData.entries()) {
      if (key === "line_id" && !skip.includes(value)) {
        const item = {
          id: parseInt(value),
          quantity: 0,
          properties: {},
        };
        const combined_lines = this.querySelectorAll(`.line__inputs[data-id="${value}"]`);
        combined_lines.forEach((line) => {
          item.quantity =
            item.quantity + parseInt(line.querySelector('[name="line_quantity"]').value);
          const multiples = line.querySelector('[name="line_properties[_multiples]"]');
          if (multiples) {
            item.properties._multiples = multiples.value;
          }
          const outer = line.querySelector('[name="line_properties[_outer]"]');
          if (outer) {
            item.properties._outer = outer.value;
          }
          const preorder = line.querySelector('[name="line_properties[_preorder]"]');
          if (preorder) {
            item.properties._preorder = preorder.value;
          }
        });
        skip.push(value);
        current.items.push(item);
      }
    }

    // clear cart and re-add products with line properties
    try {
      const clear = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      if (!clear.ok) {
        throw new Error("Something went wrong");
      }
      const rebuild = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(current),
      });
      if (!rebuild.ok) {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    } finally {
      fetchCart();
      this.reload = false;
      let finished = new CustomEvent("cart:updating", {
        detail: {
          type: "end",
        },
      });
      document.dispatchEvent(finished);
    }

    // hotfix: force credit type through to cart attributes, do not remove
    this.applyCustomerCredit();
    // endhotfix
  }
}

customElements.define("main-cart", MainCart);

class CartLines extends HTMLElement {
  constructor() {
    super();

    this.changing_lines = [];
    this.items_wrapper = this.querySelector(".cart-lines__items");
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("cart:update", this.renderItems.bind(this));
    document.addEventListener("line:update", this.renderItems.bind(this));
    this.addEventListener("line:change", this.changeLine.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.classList.contains("cart-line__remove")) {
      e.preventDefault();
      this.removeLine(e);
    }
  }

  async renderItems(e) {
    const items = e.detail.data.items;

    if (items.length <= 0) {
      this.items_wrapper.innerHTML = "";
      return;
    } else {
      const html = await this.fetchLinesHTML();
      this.items_wrapper.innerHTML = html;
    }
  }

  async fetchLinesHTML() {
    const toggle = this.getAttribute("show-toggle");
    let sectionId = "";
    if (toggle === "true") {
      sectionId = "cart-lines-html-toggle";
    } else {
      sectionId = "cart-lines-html";
    }
    try {
      const res = await fetch(`/cart?section_id=${sectionId}`);
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.text();
      const html = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector(".shopify-section").innerHTML;
      return html;
    } catch (error) {
      console.log(error);
    }
  }

  removeLine(e) {
    const line = e.target.closest(".cart-line");
    const key = line.dataset.line;
    line.classList.add("cart-line__removing");

    this.changing_lines.push({ key, quantity: 0 });
    this.debounce(() => this.updateLines());
  }

  changeLine(e) {
    const key = e.detail.key;
    const quantity = e.detail.quantity;

    this.changing_lines.push({ key, quantity });

    this.debounce(() => this.updateLines());
  }

  async updateLines() {
    let start = new CustomEvent("cart:updating", {
      detail: {
        type: "start",
      },
    });
    document.dispatchEvent(start);
    let updates = {};

    for (const line of this.changing_lines) {
      updates[line.key] = line.quantity;
    }
    try {
      const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });
      this.changing_lines = [];
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.json();
      const event = new CustomEvent("line:update", {
        detail: {
          data,
        },
      });
      document.dispatchEvent(event);
    } catch (error) {
      console.log(error);
    } finally {
      let finished = new CustomEvent("cart:updating", {
        detail: {
          type: "end",
        },
      });
      document.dispatchEvent(finished);
    }
  }

  debounce(fn, wait = 500) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}

customElements.define("cart-lines", CartLines);

class CartGifts extends HTMLElement {
  constructor() {
    super();
    const gifts = this.querySelectorAll("[data-gift]");
    this.gift_ids = [];
    for (const gift of gifts) {
      this.gift_ids.push(parseInt(gift.dataset.gift));
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("cart:update", this.updateGifts.bind(this));
    document.addEventListener("line:update", this.updateGifts.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    e.preventDefault();
    if (e.target.tagName === "BUTTON") {
      this.buildItemForm(e);
    }
  }

  buildItemForm(e) {
    const line = e.target.closest("[data-gift]");
    const item = {};
    const inputs = line.querySelectorAll("input");
    for (const input of inputs) {
      item[input.getAttribute("name")] = input.value;
    }
    const formData = new FormData();
    for (const key in item) {
      formData.append(key, item[key]);
    }

    const event = new CustomEvent("cart:add:submit", {
      detail: {
        data: formData,
        submitter: e.target,
      },
    });
    document.dispatchEvent(event);
  }

  checkGiftVisibility(e) {
    for (const gift of this.gift_ids) {
      let found = false;
      for (const item of e.detail.data.items) {
        if (item.id === gift) {
          found = true;
        }
      }
      if (found) {
        this.querySelector(`[data-gift="${gift}"]`).classList.remove("line-visible");
      } else {
        this.querySelector(`[data-gift="${gift}"]`).classList.add("line-visible");
      }
    }
  }

  async updateGifts(e) {
    const cart_template_id = this.closest(".shopify-section.cart-page").id.replace(
      "shopify-section-",
      "",
    );
    try {
      const res = await fetch(`/cart?section_id=${cart_template_id}`);
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.text();
      const html = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector(".cart-gift__lines").innerHTML;
      this.querySelector(".cart-gift__lines").innerHTML = html;
    } catch (error) {
      console.log(error);
    }
  }
}

customElements.define("cart-gifts", CartGifts);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
  }
  connectedCallback() {
    this.addEventListeners();
  }
  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("keydown", this.keyboardHandler.bind(this));
  }
  clickHandler(e) {
    const action_target =
      e.target.closest("[modal-dialog-action]")?.getAttribute("modal-dialog-action") || null;
    if (action_target === "open") {
      e.preventDefault();
      this.openModal();
    } else if (action_target === "close" || !e.target.closest(".modal-main__inner")) {
      e.preventDefault();
      this.closeModal();
    }
  }
  keyboardHandler(e) {
    if ((e.key === "Escape" || e.keyCode === 27) && this.is_open === true) {
      this.closeModal();
    }
  }
  openModal() {
    this.is_open = true;
    this.setAttribute("aria-hidden", "false");
    this.setAttribute("modal-dialog-view", "visible");
  }
  closeModal() {
    this.is_open = false;
    this.setAttribute("aria-hidden", "true");
    this.setAttribute("modal-dialog-view", "hidden");
  }
}

customElements.define("modal-dialog", ModalDialog);

class MediaZoom extends ModalDialog {
  constructor() {
    super();
    this.x = 50;
    this.y = 50;
    this.s = 100;
    this.cartridge = this.querySelector("[data-zoom-image]");

    this.eventCache = [];
    this.previousDiff = -1;
  }

  addEventListeners() {
    super.addEventListeners();
    this.cartridge.addEventListener("wheel", this.coarseHandler.bind(this));
    this.cartridge.addEventListener("mousedown", this.panStartHandler.bind(this));
    this.cartridge.addEventListener("mouseup", this.panEndHandler.bind(this));
    this.cartridge.addEventListener("mouseleave", this.panEndHandler.bind(this));
    this.cartridge.addEventListener("mousemove", this.panHandler.bind(this));

    this.cartridge.addEventListener("pointerdown", this.pointerDownHandler.bind(this));
    this.cartridge.addEventListener("pointermove", this.pointerMoveHandler.bind(this));
    this.cartridge.addEventListener("pointerup", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointercancel", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointerout", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointerleave", this.pointerUpHandler.bind(this));
  }

  openModal() {
    super.openModal();
    this.cartridgeWidth = this.cartridge.offsetWidth;
    this.cartridgeHeight = this.cartridge.offsetHeight;

    this.loadImage();
  }

  closeModal() {
    super.closeModal();
    this.x = 50;
    this.y = 50;
    this.s = 100;
    this.cartridge.removeAttribute("style");
  }

  clickHandler(e) {
    super.clickHandler(e);
  }

  setZoom(delta) {
    this.s -= delta;
    this.s = Math.min(Math.max(this.s, 100), 200);
    if (this.cartridgeWidth > this.cartridgeHeight) {
      this.cartridge.style.backgroundSize = `auto ${this.s}%`;
    } else if (this.cartridgeWidth < this.cartridgeHeight) {
      this.cartridge.style.backgroundSize = `${this.s}% auto`;
    } else {
      this.cartridge.style.backgroundSize = `${this.s}% ${this.s}%`;
    }
  }

  coarseHandler(e) {
    e.preventDefault();
    if (e.type === "wheel") {
      this.setZoom(e.deltaY);
    }
  }

  panStartHandler(e) {
    if (
      typeof this.y == "undefined" ||
      typeof this.x == "undefined" ||
      typeof this.s == "undefined"
    ) {
      this.x = 50;
      this.y = 50;
      this.s = 100;
    }
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.cartridge.classList.add("panning");
    this.mouseDown = true;
  }

  panEndHandler(e) {
    this.cartridge.classList.remove("panning");
    this.x = this.deltaX;
    this.y = this.deltaY;
    this.mouseDown = false;
  }

  panHandler(e) {
    if (!this.mouseDown) return;
    const deltaX = e.x - this.startX;
    const deltaY = e.y - this.startY;
    const deltaXPercentage = (deltaX / this.cartridgeWidth) * 100;
    const deltaYPercentage = (deltaY / this.cartridgeHeight) * 100;
    this.deltaX = Math.min(Math.max(this.x - deltaXPercentage * (this.s / 100), 0), 100);
    this.deltaY = Math.min(Math.max(this.y - deltaYPercentage * (this.s / 100), 0), 100);
    this.cartridge.style.backgroundPosition = `${this.deltaX}% ${this.deltaY}%`;
  }

  pointerDownHandler(e) {
    this.eventCache.push(e);
    if (this.eventCache.length === 1) {
      this.panStartHandler(e);
    } else {
      this.panEndHandler(e);
    }
  }

  pointerMoveHandler(e) {
    const index = this.eventCache.findIndex((cachedEvent) => cachedEvent.pointerId === e.pointerId);
    this.eventCache[index] = e;

    if (this.eventCache.length === 2) {
      const currentDiff = Math.abs(this.eventCache[0].clientX - this.eventCache[1].clientX);

      if (this.previousDiff > 0) {
        const delta = this.previousDiff - currentDiff;
        this.setZoom(delta);
      }

      this.previousDiff = currentDiff;
    } else {
      this.panHandler(e);
    }
  }

  pointerUpHandler(e) {
    const index = this.eventCache.findIndex((cachedEvent) => cachedEvent.pointerId === e.pointerId);
    this.eventCache.splice(index, 1);
    if (this.eventCache.length < 2) {
      this.previousDiff = -1;
    }
    if (this.eventCache.length <= 0) {
      this.x = this.deltaX;
      this.y = this.deltaY;
      this.mouseDown = false;
    }
  }

  loadImage() {
    this.cartridge.style.backgroundImage = `url(${this.cartridge.dataset.zoomImage})`;
  }
}

customElements.define("media-zoom", MediaZoom);

class ClearCart extends ModalDialog {
  constructor() {
    super();
  }
  clickHandler(e) {
    super.clickHandler(e);
    e.preventDefault();
    if (
      e.target.closest("[modal-dialog-event]")?.getAttribute("modal-dialog-event") === "clear-cart"
    ) {
      this.clearCart(e);
    }
  }
  async clearCart(e) {
    const submitter = e.target;
    submitter.classList.add("btn-elem--loading");
    try {
      const clear = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      if (!clear.ok) {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    } finally {
      fetchCart();
      submitter.classList.remove("btn-elem--loading");
      this.closeModal();
    }
  }
}

customElements.define("clear-cart", ClearCart);

class ImageDownload extends ModalDialog {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll(".account-order__product-select");
    this.selectToggle = this.querySelector('[modal-dialog-event="download-images-select"]');
    this.downloadButton = this.querySelector('[modal-dialog-event="download-images-submit"]');
  }

  addEventListeners() {
    super.addEventListeners();
    this.addEventListener("input", this.inputHandler.bind(this));
  }

  inputHandler(e) {
    let hasChecked = false;
    for (const checkbox of this.checkboxes) {
      if (checkbox.checked === true) {
        hasChecked = true;
        break;
      }
    }
    if (!hasChecked) {
      this.downloadButton.disabled = true;
    } else {
      this.downloadButton.disabled = false;
    }
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.closest("[modal-dialog-event]") === this.selectToggle) {
      this.selectAllToggle();
    }
    if (
      e.target.closest("[modal-dialog-event]")?.getAttribute("modal-dialog-event") ===
      "download-images-submit"
    ) {
      this.packageDownloads();
    }
  }

  closeModal() {
    super.closeModal();
    this.selectAllToggle("deselect");
  }

  selectAllToggle(type) {
    if (type && type == "deselect") {
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    } else {
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
    }
    this.dispatchEvent(new Event("input"));
  }

  async fetchImageBinary(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  async packageDownloads() {
    const zip = new JSZip();
    const directory = zip.folder("TalkingTablesDownload");

    this.selectedItems = [];
    Array.from(this.checkboxes).forEach((checkbox) => {
      const parent = checkbox.closest(".account-order__product");
      if (checkbox.checked === true) {
        this.selectedItems.push({
          title: parent.dataset.title,
          images: JSON.parse(parent.dataset.images),
        });
      }
    });

    for (const product of this.selectedItems) {
      for (const image of product.images) {
        const fileSubstring = image.substring(image.lastIndexOf("/") + 1);
        const fileName = fileSubstring.split("?")[0].toLowerCase();
        if (fileName.indexOf("private") <= 0) {
          directory.file(product.title + "/" + fileName, this.fetchImageBinary(image), {
            binary: true,
          });
        }
      }
    }

    try {
      const blob = await zip.generateAsync({ type: "blob" }, () => {
        this.downloadButton.innerText = "Gathering your files";
        this.downloadButton.disabled = true;
      });
      saveAs(blob, "TalkingTablesDownload.zip");
      this.downloadButton.innerText = "Finished";
    } catch (error) {
      console.log(error);
      this.downloadButton.innerText = "Something went wrong";
    } finally {
      setTimeout(() => {
        // this.closeModal();
        // this.selectAllToggle("deselect");
        this.downloadButton.innerText = "Download";
        this.downloadButton.disabled = false;
      }, 2000);
    }
  }
}

customElements.define("image-download", ImageDownload);

class ProductImageDownload extends HTMLElement {
  constructor() {
    super();
    this.downloadButton = this.querySelector('[download-images-event="download-images-submit"]');
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    console.log(e);
    if (
      e.target.closest("[download-images-event]")?.getAttribute("download-images-event") ===
      "download-images-submit"
    ) {
      this.packageDownloads();
    }
  }

  async fetchImageBinary(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  async packageDownloads() {
    const zip = new JSZip();
    const directory = zip.folder("TalkingTablesDownload");

    this.selectedItems = [];
    const productElement = this.querySelector(".image-download__product");
    this.selectedItems.push({
      title: productElement.dataset.title,
      images: JSON.parse(productElement.dataset.images),
    });

    for (const product of this.selectedItems) {
      for (const image of product.images) {
        const fileSubstring = image.substring(image.lastIndexOf("/") + 1);
        const fileName = fileSubstring.split("?")[0].toLowerCase();
        if (fileName.indexOf("private") <= 0) {
          directory.file(product.title + "/" + fileName, this.fetchImageBinary(image), {
            binary: true,
          });
        }
      }
    }

    try {
      const blob = await zip.generateAsync({ type: "blob" }, () => {
        this.downloadButton.innerText = "Gathering your files";
        this.downloadButton.disabled = true;
      });
      saveAs(blob, "TalkingTablesDownload.zip");
      this.downloadButton.innerText = "Finished";
    } catch (error) {
      console.log(error);
      this.downloadButton.innerText = "Something went wrong";
    } finally {
      setTimeout(() => {
        this.downloadButton.innerText = "Download product images";
        this.downloadButton.disabled = false;
      }, 2000);
    }
  }
}

customElements.define("product-image-download", ProductImageDownload);

class RepeatOrder extends ModalDialog {
  constructor() {
    super();

    this.main_message = this.querySelector("[modal-main-message]");
    this.unavailable_message = this.querySelector("[modal-unavailable-message]");
    this.alternative_message = this.querySelector("[modal-alternative-message]");
  }

  addEventListeners() {
    super.addEventListeners();
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.getAttribute("modal-dialog-action") === "open") {
      if (!this.unavailable_message) {
        this.triggerReorder();
      }
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-clear") {
      this.toggleMessage();
      this.clearCart();
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-combine") {
      this.toggleMessage();
      this.continueReorder();
    }
  }

  async triggerReorder() {
    const cart_check = await this.checkCart();
    if (!cart_check) {
      this.toggleMessage("alt");
    } else {
      this.continueReorder();
    }
  }

  async checkCart() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.json();
      if (data.item_count > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async continueReorder() {
    const form_inputs = this.querySelectorAll("form input");
    const form_data = {};
    for (const input of form_inputs) {
      let current = 0;
      if (form_data[input.dataset.id]?.quantity) {
        current = form_data[input.dataset.id].quantity;
      }
      form_data[input.dataset.id] = { properties: {} };
      form_data[input.dataset.id].quantity = current + +input.dataset.quantity;
      form_data[input.dataset.id].properties._multiples = +input.dataset.multiples;

      if (input.dataset.outer) {
        form_data[input.dataset.id].properties._outer = +input.dataset.outer;
      }
    }
    const item_data = { items: [] };
    for (const [key, value] of Object.entries(form_data)) {
      item_data.items.push({
        id: +key,
        quantity: value.quantity,
        properties: { ...value.properties },
      });
    }
    let event;
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(item_data),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      event = new CustomEvent("cart:add:success", {
        detail: {
          type: "success",
          data: {
            title: "Order",
          },
        },
      });
      fetchCart();
    } catch (error) {
      console.log(error);
      event = new CustomEvent("cart:add:error", {
        detail: {
          type: "error",
          error,
        },
      });
    } finally {
      document.dispatchEvent(event);
      this.closeModal();
    }
  }

  async clearCart() {
    try {
      const res = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
    this.continueReorder();
  }

  closeModal() {
    super.closeModal();
    this.toggleMessage();
  }

  toggleMessage(type) {
    if (type === "alt") {
      this.main_message.setAttribute("aria-hidden", "true");
      this.alternative_message.setAttribute("aria-hidden", "false");
    } else {
      this.main_message.setAttribute("aria-hidden", "false");
      this.alternative_message.setAttribute("aria-hidden", "true");
    }
  }
}

customElements.define("repeat-order", RepeatOrder);

class AccountForm extends HTMLElement {
  constructor() {
    super();
    this.form_type = this.getAttribute("form-type");
    this.form_targets = this.querySelectorAll("[data-form-target]");
    this.form_fields = this.querySelectorAll("input");
  }
  connectedCallback() {
    this.addEventListeners();
    if (this.form_type === "existing_address") {
      this.setSelectedCountry();
    } else {
      this.setReturnURL();
    }
  }
  addEventListeners() {
    this.addEventListener("submit", this.uiSubmit.bind(this));
    this.addEventListener("input", this.updateField.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }
  clickHandler(e) {
    if (
      e.target.dataset.formAction === "toggle" ||
      e.target.closest("[data-form-action]").dataset.formAction === "toggle"
    ) {
      this.toggleForms();
    }
    if (
      e.target.dataset.formAction === "set_default" ||
      e.target.closest("[data-form-action]").dataset.formAction === "set_default"
    ) {
      this.setDefaultAddress(e);
    }
  }
  toggleForms() {
    this.form_targets.forEach((form) => {
      if (form.getAttribute("aria-hidden") === "true") {
        form.setAttribute("aria-hidden", "false");
      } else {
        form.setAttribute("aria-hidden", "true");
      }
    });
  }

  // Login & register functions
  setReturnURL() {
    const return_input = this.querySelector('input[name="checkout_url"]');
    const params = new URLSearchParams(window.location.search);
    const return_url = params.get("return_url");
    if (!return_input || !return_url) return;
    return_input.value = return_url;
  }

  updateField(e) {
    e.target.setAttribute("value", e.target.value);
    if (e.target.value !== "") {
      e.target.removeAttribute("aria-invalid");
    }
  }
  uiSubmit(e) {
    e.submitter.classList.add("btn-elem--loading");
  }

  // Address functions
  setSelectedCountry() {
    const country_field = this.querySelector("[data-address-country-select]");
    const set_country = country_field.dataset.default;
    country_field.querySelector(`[value="${set_country}"]`).selected = true;
  }
  setDefaultAddress(e) {
    e.target.classList.add("btn-elem--loading");
    const edit_form = this.querySelector(".account-form__form");
    edit_form.querySelector('[name="address[default]"]').checked = true;
    edit_form.submit();
  }
}
customElements.define("account-form", AccountForm);

class DrawerNavigation extends DropdownMenu {
  constructor() {
    super();

    this.menu_parents = this.querySelectorAll(".drawer-navigation__parent-item");
    this.menu_children = this.querySelectorAll(".drawer-navigation__child-item");
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("click", this.outsideClickHandler.bind(this));
    if (!this.is_touch) {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".drawer-navigation__button")) {
      const btn = e.target.closest(".drawer-navigation__button");
      this.scrollToTop(btn);
    }
    if (e.target.closest(".drawer-navigation__backlink")) {
      const btn = e.target.closest(".drawer-navigation__backlink");
      this.scrollToTop(btn);
    }
    if (e.target.closest('.menu__button[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
    if (
      e.target.getAttribute("aria-expanded") ||
      e.target.parentElement.getAttribute("aria-expanded")
    ) {
      e.preventDefault();
      e.target.getAttribute("aria-expanded")
        ? e.target.setAttribute("aria-expanded", "true")
        : e.target.parentElement.setAttribute("aria-expanded", "true");
    }
    if (e.target.closest(".drawer-navigation__child-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__parent-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
    if (e.target.closest(".drawer-navigation__grandchild-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__child-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
  }

  scrollToTop(btn) {
    btn.closest("#drawer-menu").scrollTop = 0;
  }

  outsideClickHandler(e) {
    if (e.target.closest("drawer-navigation") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
        this.closeAllMenus();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded")) {
        e.preventDefault();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.closeAllMenus();
    }
  }

  toggleMenu() {
    super.toggleMenu();
    if (this.getAttribute("dropdown-view") === "visible") {
      this.closeAllMenus();
    }
  }

  closeAllMenus() {
    this.menu_parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
    this.menu_children.forEach((child) => {
      child.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("drawer-navigation", DrawerNavigation);

class ShippingBar extends HTMLElement {
  default_strings = {
    spend: "<p>[[remaining]] away from <strong>free delivery</strong></p>",
    eligible: "<p>You are eligible for <strong>free delivery</strong></p>",
  };

  strings = {};

  constructor() {
    super();
    this.modifier = theme.discountModifier;
    this.threshold = this.getAttribute("threshold") || 5000;
    this.total = this.getAttribute("total") || 0;
    this.eligible = this.getAttribute("shipping-bar-eligible") === "true" ? true : false;
    this.strings.spend = this.getAttribute("spend") || this.default_strings.spend;
    this.strings.eligible = this.getAttribute("eligible") || this.default_strings.eligible;
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("cart:update", this.checkEligiblity.bind(this));
    document.addEventListener("line:update", this.checkEligiblity.bind(this));
  }

  attributeChangedCallback(name, prev, next) {
    this.eligible = next === "true" ? true : false;
    this.updateBar();
  }

  static get observedAttributes() {
    return ["shipping-bar-eligible"];
  }

  checkEligiblity(e) {
    const cart_total = e.detail.data.original_total_price;
    const modified_total = cart_total * this.modifier;
    if (modified_total > parseInt(this.threshold)) {
      this.total = modified_total;
      this.setAttribute("shipping-bar-eligible", "true");
    } else {
      this.total = modified_total;
      this.setAttribute("shipping-bar-eligible", "false");
    }
  }

  updateBar() {
    const width = Math.floor((this.total / parseInt(this.threshold)) * 100);
    this.querySelector(".shipping-bar__progress--inner").style.width = `${width}%`;
    if (this.eligible) {
      this.querySelector(".shipping-bar__message").innerHTML = this.strings.eligible;
    } else {
      const remaining = this.threshold - this.total;
      this.querySelector(".shipping-bar__message").innerHTML = this.strings.spend.replace(
        /\[\[remaining\]\]/g,
        Shopify.formatMoney(remaining, theme.moneyFormat),
      );
    }
  }
}

customElements.define("shipping-bar", ShippingBar);
class MainNavigation extends HTMLElement {
  constructor() {
    super();

    this.parents = this.querySelectorAll(".main-navigation__parent-item");
    this.menu_links = this.querySelectorAll(".main-navigation__parent-menu a[data-image]");
    this.is_touch = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.parents.forEach((parent) => {
      if (this.is_touch) {
        parent.addEventListener("click", this.clickHandler.bind(this));
      } else {
        parent.addEventListener("mouseenter", this.mouseHandler.bind(this));
        parent.addEventListener("mouseleave", this.mouseHandler.bind(this));
      }
    });
    this.menu_links.forEach((link) => {
      if (!this.is_touch) {
        link.addEventListener("mouseenter", this.previewHandler.bind(this));
      }
    });

    if (this.is_touch) {
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (
      e.target.classList.contains("main-navigation__parent-button") &&
      e.target.getAttribute("aria-expanded") === "false"
    ) {
      e.preventDefault();
      this.closeAllMenus();
      e.target.setAttribute("aria-expanded", "true");
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("main-navigation") !== this) {
      this.closeAllMenus();
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseleave") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    } else if (e.type === "mouseenter") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true");
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded") === "false") {
        e.preventDefault();
        this.closeAllMenus();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.parents.forEach((parent) => {
        parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
      });
    }
  }

  previewHandler(e) {
    const image_url = e.target.dataset.image;
    const preview_container = e.target
      .closest(".main-navigation__parent-menu")
      .querySelector(".previews-active");
    if (!image_url || !preview_container) return;
    let preview_image = preview_container.querySelector("img");
    if (!preview_image) {
      preview_image = document.createElement("img");
      preview_image.setAttribute("loading", "lazy");
      preview_image.classList.add("luc-img__asset");
      preview_container.querySelector(".luc-img").appendChild(preview_image);
    }
    preview_image.src = image_url;
  }

  closeAllMenus() {
    this.parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("main-navigation", MainNavigation);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
      type: this.getAttribute("search-type") || "product,query,collection,page",
      limit: this.getAttribute("search-scope") || "10",
      scope: this.getAttribute("search-scope") || "each",
      fields:
        this.getAttribute("search-fields") ||
        "title,product_type,variants.title,variants.sku,variants.barcode,tag",
      unavailable: this.getAttribute("search-unavailable") || "last",
    };
    this.appearance = {
      type: this.getAttribute("appearance-type") || "bar",
    };
    this.predictiveSearchResults = this.querySelector("#predictive-search-results");
    this.inputWrapper = this.querySelector(".input-wrapper");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
    this.setAttribute("search-loaded", "true");
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.inputChange(event);
      }, 300).bind(this),
    );

    this.clear = this.querySelector(".input-clear");
    document.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (e.target === this.searchIcon || e.target.closest(".search-button")) {
      this.toggleSearch();
      return;
    }
    if (!e.target.closest("predictive-search")) {
      if (this.searchIcon) {
        this.toggleSearch("close");
      } else {
        this.unsetActive();
      }
      return;
    }
  }

  attributeChangedCallback(name, prev, next) {
    // triggers whenever the search-query param is set, handle everything here
    if (next === "") {
      // input field is empty, clear DOM and close results pane
      this.closeResultsPane();
      this.predictiveSearchResults.innerHTML = "";
      return;
    }
    if (prev === next && this.DOMCache) {
      return;
    }

    // new query
    this.getNewSearch();
  }

  static get observedAttributes() {
    return ["search-query"];
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  async getNewSearch() {
    this.loadingElem = this.querySelector(".predictive-search__loading");
    this.loadingElem ? this.loadingElem.setAttribute("aria-hidden", "false") : null;
    let string = `/search/suggest?q=${this.search.query}&resources[type]=${this.search.type}&resources[limit]=${this.search.limit}&resources[limit_scope]=${this.search.scope}&resources[options][fields]=${this.search.fields}&resources[options][unavailable_products]=${this.search.unavailable}&section_id=predictive-search`;
    try {
      const response = await fetch(string);
      if (!response.ok) {
        const error = new Error(response.status);
        throw error;
      }
      const data = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector("#shopify-section-predictive-search").innerHTML;
      this.DOMCache = resultsMarkup;
      this.predictiveSearchResults.innerHTML = this.DOMCache;
      this.openResultsPane();
    } catch (error) {
      this.closeResultsPane();
    }
    this.loadingElem ? this.loadingElem.setAttribute("aria-hidden", "false") : null;
  }

  positionResultsPane() {
    this.predictiveSearchResults.removeAttribute("style");
    const results = this.predictiveSearchResults.getBoundingClientRect();
    if (this.predictiveSearchResults.scrollHeight + results.top + 20 > window.innerHeight) {
      this.predictiveSearchResults.style.height = window.innerHeight - 20 - results.top + "px"; // remove an extra 20px from height to space from bottom of browser window
    }
  }

  openResultsPane() {
    this.positionResultsPane();
    if (this.predictiveSearchResults.innerHTML !== "") {
      this.predictiveSearchResults.classList.add("predictive-search-results--visible");
    }
  }

  closeResultsPane() {
    this.predictiveSearchResults.classList.remove("predictive-search-results--visible");
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  toggleSearch(force) {
    const isActive = this.searchIcon.getAttribute("aria-expanded") === "true" ? true : false;
    this.searchIcon.setAttribute("aria-expanded", !isActive);
    if (force === "close") {
      this.unsetActive();
      this.searchIcon.setAttribute("aria-expanded", "false");
    } else if (isActive) {
      this.unsetActive();
    } else {
      this.setActive();
      this.input.focus();
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
    this.openResultsPane();
  }

  unsetActive() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("input-wrapper--active");
    }
    this.closeResultsPane();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
    if (this.appearance.type == "icon") {
      const iconButton = document.createElement("button");
      const style = document.createElement("style");

      style.textContent = `
        .search-button{-webkit-appearance:none;appearance:none;width:26px;height:46px;border:0;padding:0;background:none;display:flex;align-items:center;}
        .search-button + form{display:none}
        .search-button[aria-expanded="true"] + form{display:block}
        predictive-search form{position:absolute;top:0;min-width:300px;background:#fff;right:36px;}
        @media screen and (max-width:1225px) {
          .search-button + form{display:block;opacity:0;visibility:hidden;pointer-events:none;transform:translateY(-70%);transition:all .2s ease}
          .search-button[aria-expanded="true"] + form{opacity:1;visibility:visible;pointer-events:all;transform:translateY(-50%)}
          predictive-search form{top:50%;right:0;width:calc(100% - 50px);left:0;z-index:1;transform:translateY(-50%)}
          .search-button[aria-expanded=true]{position:absolute;top:50%;right:0;background:#fff;z-index:999;width:50px;height:50px;justify-content:center;border:1px solid #c4c4c4;transform:translateY(-50%)}
          .search-button[aria-expanded=true] svg{display:none}
          .search-button[aria-expanded=true]::after,.search-button[aria-expanded=true]::before{content:"";width:15px;height:2px;display:block;background-color:var(--ttTextColor);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(45deg)}
          .search-button[aria-expanded=true]::after{transform:translate(-50%,-50%) rotate(-45deg)}
        }
      `;
      iconButton.classList.add("search-button");
      iconButton.setAttribute("aria-expanded", "false");
      iconButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23px" height="23px" viewBox="0 0 23 23" version="1.1">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Header" transform="translate(-1482.000000, -64.000000)" fill-rule="nonzero" stroke="#FFFFFF" fill="#262626">
                  <g id="Nav-bar">
                      <g transform="translate(0.000000, 30.000000)">
                          <g id="Icons" transform="translate(1396.000000, 32.000000)">
                              <g id="icon-search" transform="translate(87.000000, 3.000000)">
                                  <path d="M20.67975,19.1162632 L15.5955,13.9211579 C16.90275,12.3944211 17.619,10.4734737 17.619,8.47368421 C17.619,3.80136842 13.74975,0 8.994,0 C4.23825,0 0.369,3.80136842 0.369,8.47368421 C0.369,13.146 4.23825,16.9473684 8.994,16.9473684 C10.779375,16.9473684 12.48075,16.4183158 13.935375,15.414 L19.05825,20.6485263 C19.272375,20.867 19.560375,20.9874737 19.869,20.9874737 C20.161125,20.9874737 20.43825,20.8780526 20.648625,20.6791053 C21.095625,20.2565263 21.109875,19.5557895 20.67975,19.1162632 Z M8.994,2.21052632 C12.50925,2.21052632 15.369,5.02010526 15.369,8.47368421 C15.369,11.9272632 12.50925,14.7368421 8.994,14.7368421 C5.47875,14.7368421 2.619,11.9272632 2.619,8.47368421 C2.619,5.02010526 5.47875,2.21052632 8.994,2.21052632 Z" id="Shape"/>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
      `;
      this.appendChild(style);
      this.insertBefore(iconButton, this.firstElementChild);
      this.searchIcon = iconButton;
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);

class StaticSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
    };
    this.inputWrapper = this.querySelector(".input-wrapper");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener("input", (event) => {
      this.inputChange(event);
    });
    this.querySelector("form").addEventListener("submit", this.triggerResultsRefresh.bind(this));

    document.addEventListener("click", this.clickHandler.bind(this));
    this.clear = this.querySelector(".input-clear");
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (!e.target.closest("static-search")) {
      this.unsetActive();
      return;
    }
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  triggerResultsRefresh(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const searchParams = new URLSearchParams(formData).toString();
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParams,
        type: "q",
      },
    });
    document.dispatchEvent(event);
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
  }

  unsetActive() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("input-wrapper--active");
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
  }
}

customElements.define("static-search", StaticSearch);

class MainProduct extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("quantity:change", this.adjustQuantity.bind(this));
    this.addEventListener("submit", this.submitHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("quantity:change", this.adjustQuantity.bind(this));
    this.removeEventListener("submit", this.submitHandler.bind(this));
  }

  submitHandler(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const event = new CustomEvent("cart:add:submit", {
      detail: {
        data: formData,
        submitter: e.submitter,
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.checkNewFlag();
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  adjustQuantity(e) {
    const formQty = this.querySelector('form input[name="quantity"]');
    if (!formQty) return;
    formQty.value = e.detail.quantity;
  }

  checkNewFlag() {
    this.fallbackFlag = this.querySelector('[data-type="default"]');

    if (!this.fallbackFlag) {
      return;
    }

    const now = new Date().getTime();
    let created;
    if (this.fallbackFlag.dataset.created === "new") {
      created = now;
    } else {
      created = new Date(this.fallbackFlag.dataset.created).getTime();
    }
    const fortnight = 1209600000;
    if (now < created + fortnight) {
      this.fallbackFlag.querySelector(".flag__text").textContent = "New";
      this.fallbackFlag.classList.add("flag__show");
    }
  }
}

customElements.define("main-product", MainProduct);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.extraInformationStyle = this.getAttribute("extra-information-style");
  }

  addEventListeners() {
    this.extraInformationStyle && this.addEventListener("click", this.clickHandler.bind(this));
  }

  removeEventListeners() {
    this.extraInformationStyle && this.removeEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".accordion__toggle")) {
      const targetToggle = e.target.closest(".accordion__toggle");
      const targetToggleState = targetToggle.getAttribute("aria-expanded");
      targetToggle.setAttribute("aria-expanded", targetToggleState === "false" ? "true" : "false");
    }
  }

  connectedCallback() {
    this.checkNewFlag();
  }

  checkNewFlag() {
    this.fallbackFlag = this.querySelector('[data-type="default"]');

    if (!this.fallbackFlag) {
      return;
    }

    const now = new Date().getTime();
    let created;
    if (this.fallbackFlag.dataset.created === "new") {
      created = now;
    } else {
      created = new Date(this.fallbackFlag.dataset.created).getTime();
    }
    const fortnight = 1209600000;
    if (now < created + fortnight) {
      this.fallbackFlag.querySelector(".flag__text").textContent = "New";
      this.fallbackFlag.classList.add("flag__show");
    }
  }
}

customElements.define("product-card", ProductCard);

class CartAddForm extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("submit", this.submitHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("submit", this.submitHandler.bind(this));
  }

  submitHandler(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const event = new CustomEvent("cart:add:submit", {
      detail: {
        data: formData,
        submitter: e.submitter,
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("cart-add-form", CartAddForm);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    this.setAttribute("quantity", this.querySelector('input[name="quantity"]').value);
    this.key = this.getAttribute("key") || null;
    this.quantity = parseInt(this.querySelector('input[name="quantity"]').value) || 1;
    this.multiples = parseInt(this.getAttribute("multiples")) || this.quantity;
    this.outer = parseInt(this.getAttribute("outer")) || 1;

    this.toggle = this.querySelector(".quantity__toggle input");
    this.minusButton = this.querySelector(".quantity__button--minus");
    this.plusButton = this.querySelector(".quantity__button--plus");
    this.quantityInput = this.querySelector(".quantity__input");
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler);
    this.addEventListener("change", this.changeHandler);
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler);
    this.removeEventListener("change", this.changeHandler);
  }

  clickHandler(e) {
    if (e.target == this.minusButton) {
      if (this.quantity - this.multiples <= 0) return;
      this.quantity = this.quantity - this.multiples;
    } else if (e.target == this.plusButton) {
      this.quantity = this.quantity + this.multiples;
    }

    this.setAttribute("quantity", this.quantity);
  }

  changeHandler(e) {
    if (e.target == this.toggle) {
      this.setAttribute("size", e.target.checked ? "outer" : "inner");
    }
  }

  connectedCallback() {
    this.addEventListeners();
    if (this.toggle) {
      this.setAttribute("size", this.toggle.checked ? "outer" : "inner");
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  static get observedAttributes() {
    return ["quantity", "size"];
  }

  attributeChangedCallback(name, prev, next) {
    if (name === "quantity" && prev !== next) {
      this.quantity = parseInt(next);
      this.minusButton.setAttribute(
        "aria-label",
        `Reduce quantity to ${
          this.quantity - this.multiples < this.multiples
            ? this.quantity
            : this.quantity - this.multiples
        }`,
      );
      this.plusButton.setAttribute(
        "aria-label",
        `Increase quantity to ${this.quantity + this.multiples}`,
      );
      this.quantityInput.value = this.quantity;

      const quantityChangeEvent = new CustomEvent("quantity:change", {
        detail: {
          quantity: this.quantity,
        },
        bubbles: true,
      });
      this.dispatchEvent(quantityChangeEvent);

      if (!this.key) return;

      const event = new CustomEvent("line:change", {
        detail: {
          key: this.key,
          quantity: this.quantity,
        },
        bubbles: true,
      });
      this.dispatchEvent(event);
    } else if (name === "size") {
      if (next === "outer") {
        this.multiples = parseInt(this.getAttribute("outer")) || 1;
        if (this.quantity < parseInt(this.getAttribute("outer"))) {
          this.setAttribute("quantity", this.multiples);
        }
      } else {
        this.multiples = parseInt(this.getAttribute("multiples")) || 1;
      }
    }
  }
}

customElements.define("quantity-selector", QuantitySelector);

class RangeSlider extends HTMLElement {
  constructor() {
    super();

    this.mouseDown = false;
    this.startX = 0;
    this.handle = null;
    this.minHandle = null;
    this.maxHandle = null;
  }

  addEventListeners() {
    this.addEventListener("mousemove", this.dragHandler.bind(this));
    this.addEventListener("touchmove", this.dragHandler.bind(this));

    this.addEventListener("mousedown", this.startHandler.bind(this));
    this.addEventListener("touchstart", this.startHandler.bind(this));

    this.addEventListener("mouseup", this.endHandler.bind(this));
    this.addEventListener("touchend", this.endHandler.bind(this));
    this.addEventListener("mouseleave", this.endHandler.bind(this));

    document.addEventListener("range:set", this.setHandlePositions.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("mousemove", this.dragHandler.bind(this));
    this.removeEventListener("touchmove", this.dragHandler.bind(this));

    this.removeEventListener("mousedown", this.startHandler.bind(this));
    this.removeEventListener("touchstart", this.startHandler.bind(this));

    this.removeEventListener("mouseup", this.endHandler.bind(this));
    this.removeEventListener("touchend", this.endHandler.bind(this));
    this.removeEventListener("mouseleave", this.endHandler.bind(this));

    document.removeEventListener("range:set", this.setHandlePositions.bind(this));
  }

  connectedCallback() {
    this.minHandle = this.querySelector("#range-slider-min");
    this.maxHandle = this.querySelector("#range-slider-max");
    this.handleWidth = this.minHandle.offsetWidth;
    this.trackSize = this.offsetWidth - this.handleWidth;
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  dragHandler(e) {
    if (!this.mouseDown) return;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    const x = pageX - e.currentTarget.offsetLeft;
    let percentage = 0;
    if (this.handle.id === "range-slider-min" && x < this.handleWidth / 2) {
      this.handle.style.left = `${this.handleWidth / 2}px`;
      percentage = 0;
    } else if (
      this.handle.id === "range-slider-max" &&
      x > this.offsetWidth - this.handleWidth / 2
    ) {
      this.handle.style.left = `${this.offsetWidth - this.handleWidth / 2}px`;
      percentage = 100;
    } else {
      if (
        this.handle.id === "range-slider-min" &&
        x >= this.maxHandle.offsetLeft - this.handleWidth / 2
      ) {
        this.handle.style.left = `${this.maxHandle.offsetLeft - this.handleWidth / 2}px`;
      } else if (
        this.handle.id === "range-slider-max" &&
        x <= this.minHandle.offsetLeft + this.handleWidth * 1.5
      ) {
        this.handle.style.left = `${this.minHandle.offsetLeft + this.handleWidth * 1.5}px`;
      } else {
        this.handle.style.left = `${x}px`;
      }
      percentage = (this.handle.offsetLeft / this.trackSize) * 100;
    }

    // event to update the min and max values as percentages
    this.sendUpdatedHandleValue(this.handle.id, percentage);
  }

  startHandler(e) {
    if (!e.target.classList.contains("range-slider__handle")) return;

    this.mouseDown = true;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    this.startX = pageX - e.target.offsetLeft;
    this.handle = e.target;
  }

  endHandler(e) {
    if (this.mouseDown) {
      const event = new CustomEvent("range:complete");
      document.dispatchEvent(event);
    }
    this.mouseDown = false;
  }

  setHandlePositions(e) {
    const {
      detail: { min, max },
    } = e;

    const maxPosition = (max.current / max.limit) * 100;
    const minPosition = (min.current / max.limit) * 100;

    this.maxHandle.style.left = `${(this.trackSize / 100) * maxPosition + this.handleWidth / 2}px`;
    this.minHandle.style.left = `${(this.trackSize / 100) * minPosition + this.handleWidth / 2}px`;
  }

  sendUpdatedHandleValue(id, percentage) {
    const event = new CustomEvent("range:update", {
      detail: {
        id,
        percentage,
      },
    });
    document.dispatchEvent(event);
  }
}

customElements.define("range-slider", RangeSlider);

class ResultsGrid extends HTMLElement {
  constructor() {
    super();

    this.showCount = this.getAttribute("count-active") === "true" ? true : false;
    this.showSorting = this.getAttribute("sorting-active") === "true" ? true : false;
    this.showFilters = this.getAttribute("filters-active") === "true" ? true : false;
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("results:refresh:start", this.changeHandler.bind(this));
    window.addEventListener("popstate", () => {
      window.location.reload();
    });
    document.addEventListener("DOMContentLoaded", () => {
      const topBar = document.querySelector(".announcement-bar");
      const header = document.querySelector(".site-header");
      this.headerHeight = header?.offsetHeight + topBar?.offsetHeight;
    });
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    document.removeEventListener("results:refresh:start", this.changeHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".main-pagination__wrapper")) {
      this.paginationClick(e);
      return;
    }
    if (e.target.dataset.clear && e.target.closest(".results-grid__empty")) {
      const event = new CustomEvent("filters:clear", {
        detail: {
          changeFilter: e.target,
        },
      });
      document.dispatchEvent(event);
    }
  }

  changeHandler(e) {
    this.createSearchString(e);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  paginationClick(e) {
    e.preventDefault();
    const url = e.target.href;
    if (!url) return;
    const paginationUrl = new URL(e.target.href);
    const filteredParams = Array.from(paginationUrl.searchParams.entries()).filter((param) => {
      return param[0].indexOf("page") === 0;
    });
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: new URLSearchParams(filteredParams),
        type: "page",
      },
    });
    document.dispatchEvent(event);
  }

  createSearchString(e) {
    const type = e.detail.type;
    const currentSearchParams = Array.from(new URLSearchParams(window.location.search).entries());
    const newSearchParams = new URLSearchParams(e.detail.params);
    const filteredParams = currentSearchParams.filter((param) => {
      if (type !== "page") {
        return param[0].indexOf(type) === -1 && param[0].indexOf("page") === -1;
      } else {
        return param[0].indexOf(type) === -1;
      }
    });
    const searchString = new URLSearchParams([...filteredParams, ...newSearchParams]).toString();
    this.refreshResults(`${window.location.pathname}?${searchString}`);
  }

  updateHistory(url) {
    const currentUrl = new URL(`${window.location.origin}${url}`);
    history.pushState(null, null, currentUrl);
  }

  async refreshResults(url) {
    this.classList.add("results-grid--loading");
    let thisTop = this.offsetTop;
    if (window.innerWidth <= 767) {
      thisTop = this.offsetTop - this.headerHeight;
    }
    if (window.scrollY > thisTop) {
      window.scrollTo({
        top: thisTop,
        behavior: "smooth",
      });
    }
    try {
      const response = await fetch(`${url}`);
      const data = await response.text();
      const dataHtml = document.createElement("div");
      dataHtml.innerHTML = data;

      const products = dataHtml.querySelector(".results-grid__products");
      const pagination = dataHtml.querySelector(".results-grid__pagination");

      const productElement = this.querySelector(".results-grid__products");
      const paginationElement = this.querySelector(".results-grid__pagination");

      productElement.innerHTML = products.innerHTML;
      paginationElement.innerHTML = pagination.innerHTML;

      if (this.showCount) {
        const productsCount = dataHtml.querySelector(".results-grid__count");
        const productsCountElement = this.querySelector(".results-grid__count");
        productsCountElement.innerHTML = productsCount.innerHTML;
      }
      if (this.showFilters) {
        const dataFiltersElem = dataHtml.querySelector(".results-grid__filters");
        const currentFiltersElem = this.querySelector(".results-grid__filters");

        if (
          !dataFiltersElem.classList.contains("results-grid__filters--hide") &&
          currentFiltersElem.classList.contains("results-grid__filters--hide")
        ) {
          // if refreshed doesnt have hide class and current page has hide, indicates a matching search so insert filters
          currentFiltersElem.innerHTML = dataFiltersElem.innerHTML;
          currentFiltersElem.classList.remove("results-grid__filters--hide");
        }
        if (!currentFiltersElem.classList.contains("results-grid__filters--hide")) {
          const filters = dataHtml.querySelector(
            ".results-grid__filters .results-filters__form .form__content",
          ).outerHTML;
          const mobileButtonCount = dataHtml.querySelector(".results-filters__footer-buttons");
          const mobileButtonCountElement = this.querySelector(".results-filters__footer-buttons");
          productElement.classList.remove("results-grid__products--full");
          mobileButtonCountElement.innerHTML = mobileButtonCount.innerHTML;

          const event = new CustomEvent("results:refresh:success", {
            detail: {
              filter_data: filters,
            },
          });
          document.dispatchEvent(event);
        }
      }

      this.updateHistory(url);
    } catch (error) {
      console.log(error);
    } finally {
      this.classList.remove("results-grid--loading");
    }
  }
}

customElements.define("results-grid", ResultsGrid);

class ResultsFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
    this.windowWidth = 0;
    this.detectDevice();

    if (!this.querySelector(".price__range")) return;

    this.minPriceElem = this.querySelector('.price__range-from input[type="number"]');
    this.maxPriceElem = this.querySelector('.price__range-to input[type="number"]');
    this.minPrice = parseInt(this.minPriceElem.getAttribute("min"));
    this.maxPrice = parseInt(this.maxPriceElem.getAttribute("max"));

    this.setRangeHandles();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  detectDevice() {
    if (window.innerWidth !== this.windowWidth) {
      if (window.innerWidth <= 768) {
        this.setAttribute("aria-expanded", "false");
        this.resetDrawerState();
      } else {
        this.setAttribute("aria-expanded", "true");
      }
      this.windowWidth = window.innerWidth;
    }
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    window.addEventListener("resize", this.detectDevice.bind(this));
    document.addEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.addEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.addEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.addEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.addEventListener('input', this.inputHandler.bind(this));
    // document.addEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    window.removeEventListener("resize", this.detectDevice.bind(this));
    document.removeEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.removeEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.removeEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.removeEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.removeEventListener('input', this.inputHandler.bind(this));
    // document.removeEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  clickHandler(e) {
    if (e.detail?.changeFilter || e.target.dataset.filter || e.target.dataset.clear) {
      const target = e.detail.changeFilter ? e.detail.changeFilter : e.target;
      if (target.dataset.active) {
        e.preventDefault();
        // uncheck if active filter is clicked
        if (target.dataset.filter !== "price") {
          this.querySelector(
            `[type="checkbox"][data-filter="${target.dataset.filter}"][value="${target.dataset.value}"]`,
          ).checked = false;
        } else {
          this.querySelectorAll(`[type="number"]`).forEach((filter) => {
            filter.value = "";
            filter.setAttribute("name", "");
          });
        }
      }
      if (target.dataset.clear) {
        e.preventDefault();
        this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
          filter.checked = false;
        });
        this.querySelectorAll(`[type="number"]`).forEach((filter) => {
          filter.value = "";
          filter.setAttribute("name", "");
        });
      }
      this.checkPriceFilters();
      this.debounce(() => this.changeFilter());
      return;
    }
    if (e.target.closest(".btn-elem--price")) {
      e.preventDefault();
      this.applyPriceRange();
    }
    if (e.target.classList.contains("filter__header") || e.target.closest(".filter-option__back")) {
      // toggle filter list dropdown
      const target = e.target.closest(".filter").querySelector(".filter__header");
      const toggle = target.ariaExpanded === "true" ? true : false;
      target.ariaExpanded = !toggle;
      return;
    }
    if (e.target.classList.contains("filter__more")) {
      e.preventDefault();
      const toggle = e.target.ariaExpanded === "true" ? true : false;
      e.target.ariaExpanded = !toggle;
      e.target.textContent === theme.strings.show_more
        ? (e.target.textContent = theme.strings.show_less)
        : (e.target.textContent = theme.strings.show_more);
      return;
    }
    if (e.target.dataset.action === "open-filter-drawer") {
      this.openFilterDrawer();
      return;
    }
    if (e.target.dataset.action === "close-filter-drawer") {
      this.closeFilterDrawer();
      return;
    }
  }

  inputHandler(e) {
    if (!e.target.dataset.priceFilter) return;
    this.debounce(() => {
      this.applyPriceRange();
    }, 1000);
  }

  eventHandler(e) {
    const fragment = document.createElement("div");
    fragment.innerHTML = e.detail.filter_data;
    const filters = fragment.querySelectorAll("[data-filter]");
    filters.forEach((filter) => {
      const element = this.querySelector(
        `[data-filter="${filter.dataset.filter}"][value="${filter.value}"]`,
      );
      const parent = element.parentElement;
      element.dataset.count = filter.dataset.count;
      filter.dataset.count <= 0
        ? parent.classList.add("filter-option--nocount")
        : parent.classList.remove("filter-option--nocount");
      element.nextElementSibling.querySelector(".filter-option__count").textContent =
        `(${filter.dataset.count})`;
    });
  }

  openFilterDrawer() {
    this.setAttribute("aria-expanded", "true");
  }

  closeFilterDrawer() {
    this.setAttribute("aria-expanded", "false");
    this.debounce(() => {
      this.resetDrawerState();
    });
  }

  checkPriceFilters(e) {
    this.minPriceElem.value === "" ? (this.minPriceElem.value = this.minPrice) : null;
    this.maxPriceElem.value === "" ? (this.maxPriceElem.value = this.maxPrice) : null;

    const minElemValue = parseInt(this.minPriceElem.value);
    const maxElemValue = parseInt(this.maxPriceElem.value);

    minElemValue < this.minPrice ? (this.minPriceElem.value = this.minPrice) : null;
    minElemValue > this.maxPrice ? (this.minPriceElem.value = this.maxPrice) : null;
    maxElemValue < this.minPrice ? (this.maxPriceElem.value = this.minPrice) : null;
    maxElemValue > this.maxPrice ? (this.maxPriceElem.value = this.maxPrice) : null;

    minElemValue > maxElemValue ? (this.maxPriceElem.value = this.minPriceElem.value) : null;

    if (minElemValue === this.minPrice && maxElemValue === this.maxPrice) {
      this.minPriceElem.setAttribute("name", "");
      this.maxPriceElem.setAttribute("name", "");
    } else {
      this.minPriceElem.setAttribute("name", this.minPriceElem.dataset.priceFilter);
      this.maxPriceElem.setAttribute("name", this.maxPriceElem.dataset.priceFilter);
    }
    this.setRangeHandles();
  }

  setRangeHandles() {
    const event = new CustomEvent("range:set", {
      detail: {
        min: {
          current:
            this.minPriceElem.value !== "" ? parseInt(this.minPriceElem.value) : this.minPrice,
          limit: this.minPrice,
        },
        max: {
          current:
            this.maxPriceElem.value !== "" ? parseInt(this.maxPriceElem.value) : this.maxPrice,
          limit: this.maxPrice,
        },
      },
    });
    document.dispatchEvent(event);
  }

  updatePriceRange(e) {
    const { id, percentage } = e.detail;
    if (!this.querySelector(".filter-option--price")) return;

    const filter = this.querySelector(
      id === "range-slider-min"
        ? '.price__range-from input[type="number"]'
        : '.price__range-to input[type="number"]',
    );
    const maxValue = filter.getAttribute("max");

    filter.value = Math.round((percentage / 100) * maxValue);
  }

  applyPriceRange() {
    this.checkPriceFilters();
    this.changeFilter();
  }

  changeFilter() {
    const filtersForm = new FormData(this.querySelector("form"));
    const searchParamsArr = [];
    for (const [key, value] of filtersForm) {
      if (key.indexOf("filter") !== -1) {
        searchParamsArr.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    const searchParamsStr = searchParamsArr.join("&");
    // emit custom event with search string as payload
    const filterChangeEvent = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParamsStr,
        type: "filter",
      },
    });
    document.dispatchEvent(filterChangeEvent);
    this.updateActiveFilters(filtersForm);
  }

  createActiveFilterButton(filter) {
    const button = document.createElement("button");
    let attributes = {};
    let label = "";
    if (typeof filter[0] === "object") {
      // is price filter
      attributes = {
        "data-filter": "price",
        "data-active": "true",
        "aria-label": "Remove filter: Price range",
      };
      for (const priceGroup of filter) {
        if (priceGroup[0].indexOf("gte") !== -1) {
          attributes["data-filter-from"] = priceGroup[0];
          attributes["data-value-from"] = priceGroup[1];
        } else if (priceGroup[0].indexOf("lte") !== -1) {
          attributes["data-filter-to"] = priceGroup[0];
          attributes["data-value-to"] = priceGroup[1];
        }
      }
      label = `Price: ${Shopify.formatMoney(
        attributes["data-value-from"] * 100,
        theme.moneyFormatNoDecimals,
      )} - ${Shopify.formatMoney(attributes["data-value-to"] * 100, theme.moneyFormatNoDecimals)}`;
    } else {
      // is normal filter
      attributes = {
        "data-filter": filter[0],
        "data-value": filter[1],
        "data-active": "true",
        "aria-label": `Remove filter: ${decodeURIComponent(filter[1].replace(/\+/g, " "))}`,
      };
      label = decodeURIComponent(filter[1].replace(/\+/g, " "));
    }
    for (const key in attributes) {
      button.setAttribute(key, attributes[key]);
    }
    button.classList.add("active-filters__button");
    button.innerHTML = `${label}<span class="active-filters__cross" aria-hidden="true"></span>`;
    return button;
  }

  updateActiveFilters(filters = []) {
    const buttons = document.createDocumentFragment();
    let count = 0;
    let priceFilter = [];
    for (const filter of filters) {
      if (filter[0].indexOf("filter") !== -1) {
        if (filter[0].indexOf("filter.v.price") !== -1) {
          filter[1] !== "" ? priceFilter.push(filter) : null;
        } else {
          count++;
          const button = this.createActiveFilterButton(filter);
          buttons.appendChild(button);
        }
      }
    }
    if (priceFilter.length !== 0) {
      count++;
      const button = this.createActiveFilterButton(priceFilter);
      buttons.appendChild(button);
    }
    if (count > 0) {
      const clearButton = document.createElement("button");
      clearButton.classList.add("active-filters__clear");
      clearButton.setAttribute("data-clear", "true");
      clearButton.textContent = "Clear all";
      buttons.appendChild(clearButton);
    } else {
      this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
        filter.checked = false;
      });
      this.querySelectorAll(`[type="number"]`).forEach((filter) => {
        filter.value = null;
      });
    }
    const activeFilters = this.querySelector(".active-filters");
    activeFilters.replaceChildren(buttons);
    this.querySelectorAll(".active-filters").forEach((container, index) => {
      if (index !== 0) {
        container.innerHTML = activeFilters.innerHTML;
      }
    });
  }

  resetDrawerState() {
    this.querySelectorAll(".filter__header").forEach((header) => {
      header.setAttribute("aria-expanded", "false");
    });
  }

  debounce(fn, wait = 300) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("results-filters", ResultsFilters);

class ResultsSorting extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("input", this.changeHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("input", this.changeHandler.bind(this));
  }

  changeHandler(e) {
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: `sort_by=${e.target.value}`,
        type: "sort_by",
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("results-sorting", ResultsSorting);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".main-product__tab");
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  connectedCallback() {
    this.addEventListeners();
  }

  clickHandler(e) {
    if (e.target.classList.contains("tab-heading")) {
      this.toggleTab(e.target.closest(".main-product__tab"));
    }
  }

  toggleTab(tab) {
    const isOpen = tab.getAttribute("aria-expanded") === "true";
    tab.setAttribute("aria-expanded", !isOpen);
  }
}

customElements.define("product-tabs", ProductTabs);

class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.defaultThumbsOptions = {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 4,
      watchSlidesProgress: true,
      grid: {
        fill: "row",
        rows: 5,
      },
    };

    this.elements = {
      swiper: this.querySelector(".media-gallery"),
      pagination: this.querySelector(".media-gallery__pagination"),
      prevButton: this.querySelector(".media-gallery__button-prev"),
      nextButton: this.querySelector(".media-gallery__button-next"),
      thumbs: this.querySelector(".media-gallery__thumbs"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.galleryOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.galleryOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }

    if (this.elements.thumbs) {
      this.thumbsSwiperOptions = {
        ...this.defaultThumbsOptions,
      };
      if (this.elements.thumbs.dataset.galleryOptions) {
        this.thumbsSwiperOptions = {
          ...this.defaultThumbsOptions,
          ...JSON.parse(this.elements.thumbs.dataset.galleryOptions),
        };
      }
      this.swiperOptions.thumbs = {
        swiper: this.elements.thumbs,
      };
    }
    this.mediaZoom = this.querySelector("media-zoom");
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.classList.contains("media-gallery__play")) {
      this.videoSlide = e.target.closest(".media-gallery__slide-video");
      this.videoSlideMedia = this.videoSlide.querySelector("video");
      this.featuredVideo = document.querySelector("featured-video");
      if (this.videoSlideMedia) {
        this.playMedia(e);
      } else if (this.featuredVideo) {
        this.scrollToVideo();
      }
    }
  }

  init() {
    if (!this.elements.swiper) return;
    if (this.elements.thumbs) {
      this.thumbsSwiper = new Swiper(this.elements.thumbs, this.thumbsSwiperOptions);
    }
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);

    this.swiper.on("slideChange", () => {
      const activeSlide = this.swiper.slides[this.swiper.activeIndex];
      if (this.activeVideo) {
        this.activeVideo.pause();
        this.activeVideo.currentTime = 0;
        this.videoSlide.classList.remove("video-playing");
      }
      if (!this.mediaZoom) return;
      if (activeSlide.querySelector(".media-gallery__slide-video")) {
        this.mediaZoom.classList.add("hide-zoom");
      } else {
        this.mediaZoom.classList.remove("hide-zoom");
      }
      const slideMediaURL = new URL(activeSlide.querySelector(".luc-media img").src);
      slideMediaURL.searchParams.set("width", 2560);

      this.mediaZoom.querySelector("[data-zoom-image]").dataset.zoomImage = slideMediaURL;
    });
  }

  playMedia() {
    this.videoSlide.classList.add("video-playing");
    this.activeVideo = this.videoSlideMedia;
    this.videoSlideMedia.play();
  }
  scrollToVideo() {
    const topBar = document.querySelector(".announcement-bar");
    const header = document.querySelector(".site-header");
    this.headerHeight = header?.offsetHeight + topBar?.offsetHeight;
    window.scrollTo({
      top: this.featuredVideo.offsetTop - this.headerHeight,
      behavior: "smooth",
    });
  }
}
customElements.define("media-gallery", MediaGallery);

class FeaturedVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.classList.contains("media-gallery__play")) {
      this.playMedia(e);
    }
  }

  playMedia(e) {
    const video = this.querySelector("video");

    if (!video) return;

    this.querySelector(".featured-video-body").classList.add("video-playing");
    video.play();
  }
}
customElements.define("featured-video", FeaturedVideo);

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
      this.elements.swiper.dataset.alignArrows
        ? (this.align_arrows = JSON.parse(this.elements.swiper.dataset.alignArrows))
        : null;
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    window.addEventListener("resize", this.positionArrows.bind(this));
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
    this.positionArrows();
  }

  positionArrows() {
    setTimeout(() => {
      if (!this.align_arrows || !this.elements.prevButton || !this.elements.nextButton) return;
      const slide_image_height = this.swiper.slidesEl.querySelector(".luc-media")?.offsetHeight;
      this.elements.nextButton.style.top = slide_image_height / 2 + "px";
      this.elements.nextButton.style.marginTop = -this.elements.nextButton.offsetHeight / 2 + "px";
      this.elements.prevButton.style.top = slide_image_height / 2 + "px";
      this.elements.prevButton.style.marginTop = -this.elements.prevButton.offsetHeight / 2 + "px";
    }, 1);
  }
}
customElements.define("main-carousel", MainCarousel);

class RecentlyViewedCarousel extends MainCarousel {
  constructor() {
    super();
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.fetchRecentlyViewed.bind(this));
  }

  async fetchRecentlyViewed() {
    if (!this.recentlyViewedHandles) return;

    try {
      const res = await fetch(
        `/search?view=recently-viewed-items&q=${this.recentlyViewedHandles.join(",")}`,
      );
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data);
    } catch (error) {
      console.log(error);
    }
  }

  renderRecentlyViewed(data) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".main-carousel__wrapper").innerHTML;
    const item_wrapper = this.querySelector(".main-carousel__wrapper");
    item_wrapper.innerHTML = items;
    this.init();
    this.closest(".recently-viewed-carousel").style.display = "block";
  }
}
customElements.define("recently-viewed-carousel", RecentlyViewedCarousel);

class RecommendationsCarousel extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }

    this.limit = this.getAttribute("limit") || "8";
    this.intent = this.getAttribute("intent") || "related";
    this.product_id = this.getAttribute("product_id");
    this.section_id = this.getAttribute("section_id");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {}

  async init() {
    if (!this.elements.swiper) return;
    const base_url = `${window.Shopify.routes.root}recommendations/products?section_id=${this.section_id}&product_id=${this.product_id}&limit=${this.limit}`;
    if (this.intent === "both") {
      const complementary = await this.getRecommendations(`${base_url}&intent=complementary`);
      if (complementary) {
        this.renderRecommendations(complementary);
      } else {
        const related = await this.getRecommendations(`${base_url}&intent=related`);
        if (related) {
          this.renderRecommendations(related);
        } else {
          this.style.display = "none";
        }
      }
    } else {
      const recommendations = await this.getRecommendations(`${base_url}&intent=${this.intent}`);
      if (recommendations) {
        this.renderRecommendations(recommendations);
      }
    }
  }

  async getRecommendations(url) {
    try {
      const response = await fetch(url);
      const data = await response.text();
      const html = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector(".main-product__complementary .main-carousel__wrapper");
      if (html.children.length > 0) {
        return html.innerHTML;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  }

  renderRecommendations(data) {
    this.elements.swiper.querySelector(".main-carousel__wrapper").innerHTML = data;
    this.closest(".main-product__complementary").style.display = "block";
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}
customElements.define("recommendations-carousel", RecommendationsCarousel);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }

    this.limit = this.getAttribute("limit") || "10";
    this.intent = this.getAttribute("intent") || "related";
    this.section_id = this.getAttribute("section_id");
    this.allProductsString = this.dataset.products
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {}

  async init() {
    if (!this.elements.swiper) return;
    this.allProductsIdArray = this.allProductsString.split(",");   
    if (this.allProductsIdArray.length === 3) {
      this.limit = 4
    } else if (this.allProductsIdArray.length === 2) {
      this.limit = 6
    } else {
      this.limit = 10
    }

    const urls = []
    this.allProductsIdArray.forEach((productID) => {
      urls.push(`${window.Shopify.routes.root}recommendations/products?section_id=${this.section_id}&product_id=${productID}&limit=${this.limit}`)
    })

    // left in option for different intent but current use will always default to related
    if (this.intent === "both") {
      const complementary = await this.getRecommendations(urls, this.intent);
      if (complementary) {
        this.renderRecommendations(complementary);
      } else {
        const related = await this.getRecommendations(urls, this.intent);
        if (related) {
          this.renderRecommendations(related);
        } else {
          this.style.display = "none";
        }
      }
    } else {
      const recommendations = await this.getRecommendations(urls, this.intent);
      if (recommendations) {
        this.renderRecommendations(recommendations);
      }
    }
  }

  async getRecommendations(urls, intent) {
    try {
      const responses = await Promise.all(
        urls.map((url)=>{
          return fetch(`${url}&intent=${intent}`)
        })
      )
      const domArray = await Promise.all(
        responses.map((response) => response.text())
      );

      const allProductSlides = (
          domArray.map((html) => {
            const nodes = new DOMParser()
              .parseFromString(html, "text/html")
              .querySelectorAll("cart-recommendations .swiper-slide");
            return Array.from(nodes);
          }
        )
      ).flat();

      return allProductSlides
    } catch (error) {
      console.log(error);
    }
  }

  renderRecommendations(data) {
    if (data.length <= 0) return;
    data.forEach((slide) => {
      this.elements.swiper.querySelector(".main-carousel__wrapper").appendChild(slide)
    })
    this.closest(".cart-related").style.display = "block";
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}

customElements.define("cart-recommendations", CartRecommendations);

function addItem(e) {
  e.preventDefault();
  const formData = new FormData(e.target);
  const event = new CustomEvent("cart:add:submit", {
    detail: {
      data: formData,
      submitter: e.submitter,
    },
  });
  document.dispatchEvent(event);
}
// Global event functions
const addItemToCart = async (e) => {
  let event;
  const submitter = e.detail.submitter;
  const formData = e.detail.data;
  submitter.classList.add("btn-elem--loading");
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHTTPRequest",
      },
      credentials: "same-origin",
      body: formData,
    });
    const data = await response.json();
    if (_learnq) {
      pushKlaviyo(data);
    }
    if (!response.ok) {
      throw new Error("Something went wrong");
    }
    event = new CustomEvent("cart:add:success", {
      detail: {
        type: "success",
        data,
      },
    });
    fetchCart();
  } catch (error) {
    console.log(error);
    event = new CustomEvent("cart:add:error", {
      detail: {
        type: "error",
        error,
      },
    });
  } finally {
    submitter.classList.remove("btn-elem--loading");
    document.dispatchEvent(event);
  }
};

const fetchCart = async () => {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) {
      throw new Error("Something went wrong");
    }
    const data = await res.json();
    const event = new CustomEvent("cart:update", {
      detail: {
        data,
      },
    });
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
};

// Custom event listeners
document.addEventListener("cart:add:submit", addItemToCart);

function pushKlaviyo(data) {
  const item = {
    Name: data.title,
    ProductID: data.id,
    ImageURL: data.image,
    URL: `${window.location.origin}${data.url}`,
    Brand: data.vendor,
    Price: Shopify.formatMoney(data.price, theme.moneyFormat),
    CompareAtPrice: Shopify.formatMoney(
      data.original_price === data.price ? 0 : data.original_price,
      theme.moneyFormat,
    ),
  };
  _learnq.push(["track", "Added to Cart", item]);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function trackRecentlyViewed(handle) {
  let recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewedItems"));
  if (!recentlyViewed) {
    recentlyViewed = [];
  }
  if (recentlyViewed.indexOf(handle) === -1) {
    recentlyViewed.unshift(handle);
  } else {
    const index = recentlyViewed.indexOf(handle);
    recentlyViewed.splice(index, 1);
    recentlyViewed.unshift(handle);
  }
  recentlyViewed = recentlyViewed.slice(0, 9);
  localStorage.setItem("recentlyViewedItems", JSON.stringify(recentlyViewed));
}
